// ============================================================================
// Theme vocabulary
// Shared constants for light / dark / system theming. The theme LOGIC lives in
// common/theme.js; these are the plain values it (and any consumer) reference.
// The resolved palette itself is NOT here — colours live in theme.css as CSS
// variables (single source of truth); theme.js reads the active --background
// token for the mobile browser-chrome colour rather than duplicating hexes.
// ============================================================================

/** User's theme choice. "system" follows the OS `prefers-color-scheme`. */
export const ThemePreference = Object.freeze({
  Light: "light",
  Dark: "dark",
  System: "system",
});

/** localStorage key holding the persisted ThemePreference. */
export const THEME_STORAGE_KEY = "pellerex.theme";

/** window CustomEvent dispatched when the theme changes (user or OS). */
export const THEME_CHANGE_EVENT = "pellerex:themechange";

/** Class set on <html> when the resolved theme is dark; every token in theme.css keys off it. */
export const DARK_CLASS = "dark";
